<template>
  <div>
    <vx-tooltip
      :delay="tooltipDelay"
      :text="tooltipText"
      :tooltipPosition="tooltipPosition"
    >
      <feather-icon
        icon="DollarSignIcon"
        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
        @click="open"
      />
    </vx-tooltip>
    <vs-popup fullscreen :title="$t('link_expenses')" :active.sync="active">
      <div>
        <h4>{{ $t('information') }}</h4>
        <vs-row class="my-3">
          <vs-col vs-w="3">
            <b>{{ $t('client') }}:</b> {{ data.ClientName }}
          </vs-col>
          <vs-col vs-w="5">
            <b>{{ $t('period') }}:</b> {{ data.WeekInvoice }}
          </vs-col>
          <vs-col vs-offset="2" vs-w="2">
              <vs-button
                color="success"
                type="filled"
                icon-pack="feather"
                icon="icon-link"
                class="w-full"
                @click="openConfirm"
                v-show="selected.length > 0"
              >
                {{ $t('link_expenses') }}
              </vs-button>
          </vs-col>
        </vs-row>
        <vs-table :data="expenses">
          <template slot="thead">
            <th><vs-checkbox v-model="selectAllCheckBox" icon-pack="feather" :icon="selectAllIcon" class="select-all-chexkbox ml-0"></vs-checkbox></th>
            <th>{{ $t('vendor') }}</th>
            <th>{{ $t('category') }}</th>
            <th>{{ $t('folio') }}</th>
            <th :style="{ textAlign:'center'}">{{ $t('date') }} </th>
            <th :style="{ textAlign:'right'}">{{ $t('total') }}</th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="i" v-for="(tr, i) in data">
              <vs-td :style="{ width: '2vw' }">
                <vs-checkbox
                  :vs-value="data[i].ExpenseId"
                  v-model="selected"
                ></vs-checkbox>
              </vs-td>
              <vs-td :style="{ width: '35vw' }" class="text-left">{{ tr.VendorName }}</vs-td>
              <vs-td :style="{ width: '24vw' }" class="text-left">{{ tr.CategoryName }}</vs-td>
              <vs-td :style="{ width: '10vw' }" class="text-left">{{ tr.Folio }}</vs-td>
              <vs-td :style="{ width: '10vw' }" class="text-center">{{
                formatDate(tr.ReceivedDate)
              }}</vs-td>
              <vs-td :style="{ width: '19vw' }" class="text-right">{{
                `$ ${Number(tr.Total).toLocaleString('en-US')} ${tr.CurrencyId}`
              }}</vs-td>
            </vs-tr>
            <vs-tr v-show="expenses.length == 0">
              <vs-td colspan="6" class="text-center">
                <p>{{ tableMessage }}</p>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
       <vs-popup :title="$t('confirm')" :active.sync="confirmActive">
        <p>{{$t('are_you_sure')}} {{$t('once_approved_you_can_not_undo_this_action')}}</p>
        <vs-row
          vs-align="center"
          vs-type="flex"
          vs-justify="center"
          class="mt-4"
        >
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="6"
            class="mt-2 px-2"
          >
            <vs-button
             ref="loadableButton" 
             id="link-button-loading" 
             class="w-full vs-con-loading__container" 
              color="primary"
              type="filled"
              :disabled="submitButtonText != $i18n.messages[$i18n.locale].submit"
              @click="linkExpenses"
              >{{submitButtonText}}</vs-button
            >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="6"
            class="mt-2 px-2"
          >
            <vs-button
              color="primary"
              type="border"
              class="w-full"
              :disabled="submitButtonText != $i18n.messages[$i18n.locale].submit"
              @click="confirmActive = false"
              >{{ $t('cancel') }}</vs-button
            >
          </vs-col>
        </vs-row>
      </vs-popup>
    </vs-popup>
  </div>
</template>

<script>
import invoice from '@/http/requests/invoice'
import loading from '@/mixins/Loading.js'

export default {
  mixins: [loading],
  props: {
    btnColor: {
      type: String,
      default: 'primary'
    },
    btnType: {
      type: String,
      default: 'border'
    },
    btnIcon: {
      type: String,
      default: ''
    },
    btnText: {
      type: String,
      default: 'button'
    },
    popupTitle: {
      type: String,
      default: 'title'
    },
    tooltipDelay: {
      type: String,
      default: '1.5s'
    },
    tooltipPosition: {
      type: String,
      default: 'top'
    },
    tooltipText: {
      type: String,
      default: null
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      active: false,
      confirmActive: false,
      lastPage: 1,
      params: {
        page: 1
      },
      expenses: [],
      selected: [],
      tableMessage:'', 
      submitButtonText:this.$i18n.messages[this.$i18n.locale].submit
    }
  },
  computed:{
    selectAllCheckBox: {
      get () {
        return this.selected.length
      },
      set (value) {
        value ? this.selected = this.expenses.map(expense => expense.ExpenseId) : this.selected = []
      }
    },
    selectAllIcon () {
      return this.selected.length === this.expenses.length ? 'icon-check' : 'icon-minus'
    }
  },
  methods: {
    open() {
      this.active = true
      this.selected = []
      this.expenses = []
      this.search()
    },
    search() {
      this.tableMessage= this.$i18n.messages[this.$i18n.locale].loading+'...'
      this.params.where = ['Expenses.ClientId=' + this.data.ClientId]
      invoice.expenseListToLink(this.params).then(res => {
        this.expenses = res.data.data
        if (res.data.data.length == 0) {
          this.tableMessage = this.$i18n.messages[this.$i18n.locale].no_results
        }
      })
    },
     openConfirm() {
       this.confirmActive=true
    },
    linkExpenses() {
      this.submitButtonText=this.$i18n.messages[this.$i18n.locale].loading+'...'
      this.openLoading('link-button-loading')
      let params = { 
        expenseIds: this.selected,
        invoiceId : this.data.InvoiceId
        }
      invoice.linkExpensesToInvoice(params).then(res => {
        this.$vs.notify({
          color: 'success',
          title: 'Success',
          text: this.$i18n.messages[this.$i18n.locale].invoice_linked
        })
        this.closeLoading('link-button-loading')
        this.confirmActive=false
        this.active = false
        this.submitButtonText=this.$i18n.messages[this.$i18n.locale].submit
      }).catch(err => {
        console.log(err)
        this.$vs.notify({
          color: 'danger',
          title: 'Oops...',
          text: 'Something went wrong'
        })
        this.submitButtonText=this.$i18n.messages[this.$i18n.locale].submit
        this.closeLoading('link-button-loading')
      })

    }
  },

}
</script>


<style>
.text-center {
  text-align: center;
}
</style>